import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import { FaStar } from "react-icons/fa";
import axios from 'axios';
import { useJwt } from "react-jwt";
import { CreateSlider, GetAllMedia, GetCategoryImage, GetProductStatus, api_url } from '../apiconfig/authService';
import { toast } from 'react-toastify';
import { RiLoaderFill } from "react-icons/ri";

function AddSlider(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const setMediaTableViewMessage = props.setMessage;

  const [statusid, setStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [mediaData, setMediaData] = useState([]);
  const [selectedMedias, setSelectedMedias] = useState([]);

  const [sliderTitle, setSliderTitle] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSliderTitleChange = (e) => {
    setSliderTitle(e.target.value);
  };

  const handleStatusIdChange = (e) => {
    setStatusid(e.target.value);
  };

  const handleImageClick = (mediaid) => {
    const isSelected = selectedMedias.some((item) => item === mediaid);

    if (isSelected) {
      setSelectedMedias(selectedMedias.filter((item) => item !== mediaid));
    } else {
      setSelectedMedias([...selectedMedias, mediaid]);
    }
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!sliderTitle.trim()) {
        toast.error("Slider title is required!");
        return;
      }
      if (selectedMedias.length === 0) {
        toast.error("Slider image is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const requestBody = {
      title: sliderTitle,
      relatedMedias: selectedMedias,
      statusid
    };
    try {
      setLoading(true);
      response = await CreateSlider(requestBody, localStorage.getItem('accessToken'));
      if (response.status === 201) {
        setLoading(false);
        toast.success("Slider Added Successfully");
        setMediaTableViewMessage(response.data.message);
        navigate("/slider");
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setLoading(false);
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (
      async () => {
        try {

          const statusResponse = await GetProductStatus(localStorage.getItem('accessToken'));
          setStatusData(statusResponse.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
    (
      async () => {
        try {
          const mediaResponse = await GetAllMedia(localStorage.getItem('accessToken'));
          setMediaData(mediaResponse.data);
        } catch (error) {
          console.log(error);
        }
      }
    )();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Slider</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/media" className="btn btn-primary">View All</NavLink>
          </div>
        </div>
        <div role="tabpanel" className="personal-info tab-pane active" id="pi">
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <div className="form-floating mb-4">
                <input type="text" value={sliderTitle} onChange={handleSliderTitleChange} className="form-control" id="catName" placeholder="Product Main Category Name" />
                <label htmlFor="catName" className="d-flex align-items-center gap-1">
                  Slider Title <FaStar size={7} className="text-danger" />
                </label>
              </div>
            </div>
          </div>
          <div className="form-floating mb-4">
            <select className="form-select" onChange={handleStatusIdChange} value={statusid} >
              {
                statusData?.map((item, index) => (
                  <option value={item.statusid} key={index}>
                    {item.status}
                  </option>
                ))
              }
            </select>
            <div className="d-flex mt-2">
              <label>Status</label>
              <FaStar size={7} className="text-danger" />
            </div>
          </div>
          <div className='row'>
            {
              mediaData?.map((item, index) => (
                <div className='col-lg-2' key={index}>
                  <input className="form-check-input" onChange={() => handleImageClick(item.mediaid)} checked={selectedMedias.find(mediaid => mediaid === item.mediaid)} type="checkbox" />
                  <img width="100px" height="100px" onClick={() => handleImageClick(item.mediaid)} style={{ marginLeft: 20, marginRight: 20, marginBottom: 20 }} src={`${api_url}/product/category/getCategoryImage/${item.image}`} />
                </div>
              ))
            }
          </div>
          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  disabled={loading}
                  onClick={handleSubmitClick}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddSlider;
